'use client';
import Image from 'next/image';

const Slider = ({
  backgroundImage,
  heading,
  subheading,
  description,
  buttonText,
  buttonLink,
}) => {
  return (
    <div className="page-heading py-14 md:py-16 lg:py-20 relative z-0 before:-z-10">
      <Image
        src={backgroundImage}
        fill
        alt="Slide Background"
        className="absolute object-cover -z-20 !left-400px"
        style2={{ left: '400px' }}
      />
      <div className="max-w-screen-xl mx-5 lg:mx-auto relative -z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-0 items-center justify-between text-white lg:pb-24">
          <div>
            <p className="text-white font-semibold uppercase font-serif text-opacity-60 mb-2">
              {subheading}
            </p>
            <h1 className="font-extrabold mb-4">{heading}</h1>
            <div className="text-base md:text-lg mb-4">{description}</div>
            <div className="mt-6 md:mt-8 ">
              <a
                href={buttonLink}
                className="btn-theme px-8 py-3 lg:px-12 lg:py-4 rounded-lg bg-blue-600 text-white hover:bg-blue-700 focus:ring-4 focus:ring-blue-300"
              >
                {buttonText}
              </a>
            </div>
          </div>
          <div className="md:col-span-2"></div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
